<template>
  <div id="property-plan"  v-show="isDetailPage">
    <!-- ルームプランモーダル -->
    <dd-property-plan-modal
      ref="propertyPlanModalRef"
      :roomPlanList="roomPlanList"
      :businessList="businessList"
      :roomList="roomList"
      :fileDataList="fileDataList"
      :propertyData="propertyData"
      @showDetailPage="showDetailPage"
      @getPropertyPlanData="getPropertyPlanData"
    />
    <!-- 絞り込み検索モーダル -->
    <dd-property-search-modal
      ref="planSearchRef"
      :isDetailPage="isDetailPage"
      @onClickSearch="onClickSearch"
    />
    <!-- コンテキストメニュー -->
    <dd-plan-context-menu
      ref="contextMenuRef"
      :selectedPlan="selectedPlan"
      :isDetailPage="isDetailPage"
      :fileDataList="fileDataList"
      @openEditModal="openEditModal"
      @openCopyModal="openCopyModal"
    />
    <!--  タイトルエリア  -->
    <!-- <div class="title_area">
      <h3 v-if="isDetailPage">物件管理 → 受注処理</h3>
    </div> -->
    <div v-if="this.propertyData" class="form_area">
      <div class="sub_title_area">
      <h3><span>{{ this.propertyData.cpropertyCd}}</span>
        <span>{{ this.propertyData.cpropertyName}}</span></h3>
        <span>{{ this.propertyData.propertyClientName}}</span>
        <span>（担当：{{ this.propertyData.propertyClientPersonName}}）</span>
      </div>
    </div>
    <div class="form_area">
      <div class="button_area">
        <button class="main_btn register_btn" @click="openNewModal">プラン新規登録</button>
        <button class="main_btn"  @click="$emit('backMainPage')">物件管理</button>
        <button class="main_btn" @click="openSearchModal">絞り込み検索</button>
        <button class="main_btn" @click="downLoadCsv">CSV出力</button>
      </div>
      <!-- ページ -->
      <div>
        <dd-pager
          ref="pagerRef"
          :pageNo="pageNo"
          :dataCountPerPage="dataCount"
          :totalDataCount="totalCount"
          @paging="paging"
        />
      </div>
      <!-- 表示項目切り替え -->
      <div class="disp_btn" @click="openDispModal">
        <div class="disp_icon">
          <span class="displogo"></span>
          <span class="displogo"></span>
          <span class="displogo"></span>
        </div>
        <div class="disptitle">表示項目</div>
      </div>
    </div>
    <!-- データテーブル -->
      <div class="room_plan_list_area">
        <table>
          <thead>
            <tr>
              <th :class="{none: checkDisp(20)}">棟名</th>
              <th :class="{none: checkDisp(21)}">フロア名</th>
              <th :class="{none: checkDisp(22)}">ルーム名</th>
              <th :class="{none: checkDisp(23)}">場所名</th>
              <th :class="{none: checkDisp(24)}">UMコード</th>
              <th :class="{none: checkDisp(25)}">プラン名</th>
              <th :class="{none: checkDisp(26)}">数量</th>
              <th :class="{none: checkDisp(27)}">納入先名</th>
              <th :class="{none: checkDisp(28)}">納入先部署名</th>
              <th :class="{none: checkDisp(29)}">納入先担当者名</th>
              <th :class="{none: checkDisp(30)}">着荷日</th>
              <th :class="{none: checkDisp(31)}">納入時刻</th>
            </tr>
          </thead>
          <tbody @mouseover="isOnListArea = true" @mouseout="isOnListArea = false" @contextmenu.prevent>
            <tr v-for="(plan, index) in roomPlanList"
              :key ="index"
              @mouseover="mouseover(plan)"
              @mouseup="isDetailPage && mouseup($event)"
              class="hover_color"
            >
              <td :class="{none: checkDisp(20)}">{{ plan.dpropertyRoom.cpropertyBuildingName }}</td>
              <td :class="{none: checkDisp(21)}">{{ plan.dpropertyRoom.cpropertyFloorName }}</td>
              <td :class="{none: checkDisp(22)}">{{ plan.dpropertyRoom.cpropertyRoomName }}</td>
              <td :class="{none: checkDisp(23)}">{{ plan.cpropertyRoomPlaceName }}</td>
              <td :class="{none: checkDisp(24)}">{{ plan.fileCode }}</td>
              <td :class="{none: checkDisp(25)}">{{ plan.fileName }}</td>
              <td :class="{none: checkDisp(26)}">{{ plan.cpropertyRoomFdCount }}</td>
              <td :class="{none: checkDisp(27)}">{{ plan.businessName }}</td>
              <td :class="{none: checkDisp(28)}">{{ plan.businessDepartment }}</td>
              <td :class="{none: checkDisp(29)}">{{ plan.businessPersonName}}</td>
              <td :class="{none: checkDisp(30)}">{{ getFormatDate(plan.cpropertyArrivalDate) }}</td>
              <td :class="{none: checkDisp(31)}">{{ plan.cpropertyDeliveryTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </main> -->
    </div>
  </template>
<script>
// Module
import axios from 'axios'
import moment from 'moment'
import encoding from 'encoding-japanese'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {API_URL, MOUSE_BUTTON, STORAGE_KEY} from '../../constants/App'
import PropertyPlanModal from '../list/modal/PropertyPlanModal'
import PlanContextMenu from '../list/PlanContextMenu'
import PropertySearchModal from '../list/modal/PropertySearchModal'
import Pager from '../../components/common/OrderPager'

export default {
  name: 'PropertyPlanTable',
  components: {
    'dd-property-plan-modal': PropertyPlanModal,
    'dd-plan-context-menu': PlanContextMenu,
    'dd-property-search-modal': PropertySearchModal,
    'dd-pager': Pager
  },
  props: {
    isDetailPage: Boolean,
    dispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** 物件情報 */
      propertyData: null,
      /** ルームプランリスト */
      roomPlanList: [],
      /** 納入先リスト */
      businessList: [],
      /** ルームリスト */
      roomList: [],
      /** ファイルデータリスト */
      fileDataList: [],
      /** 選択中ルームプラン */
      selectedPlan: null,
      /** リスト上フラグ */
      isOnListArea: false,
      searchForm: {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: '',
        pageNo: '',
        dataCount: ''
      }
    }
  },
  methods: {
    /** 物件詳細情報を表示 */
    showDetailPage: function (data) {
      if (data) {
        this.propertyData = data
        this.getPropertyPlanData(data.cpropertyId)
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PROPERTY_SEARCH)
      }
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 物件詳細一覧を取得 */
    onSearch: function (searchForm) {
      App.setLocalStorage(STORAGE_KEY.PROPERTY_SEARCH, searchForm)
      searchForm.propertyId = this.propertyData.cpropertyId
      axios.post(API_URL.PROPERTY + '/plan/info', searchForm
      ).then(response => {
        this.roomPlanList = response.data.data.roomPlanList
        this.totalCount = response.data.data.propertyCount
        this.businessList = response.data.data.businessList
        this.fileDataList = response.data.data.fileDataList
        this.roomPlanList
          .forEach(plan => {
            if (plan.cpropertyRoomTargetId) {
              if (plan.mbusiness) {
                plan.businessName = plan.mbusiness.cbusinessName
                plan.businessDepartment = plan.mbusiness.cbusinessDepartment
                let parsonLastName = plan.mbusiness.cbusinessPersonLastName1 !== null ? plan.mbusiness.cbusinessPersonLastName1 : ''
                let parsonFirstName = plan.mbusiness.cbusinessPersonFirstName1 !== null ? plan.mbusiness.cbusinessPersonFirstName1 : ''
                plan.businessPersonName = parsonLastName + ' ' + parsonFirstName
              } else {
                plan.businessName = '（削除済）'
                plan.businessDepartment = '（削除済）'
                plan.businessPersonName = '（削除済）'
              }
            } else {
              plan.businessName = ''
              plan.businessDepartment = ''
              plan.businessPersonName = ''
            }
            if (plan.dfileData) {
              plan.fileName = plan.dfileData.cfileName
              plan.fileCode = plan.dfileData.cfileCode
            } else {
              plan.fileName = '（削除済）'
              plan.fileCode = '（削除済）'
            }
          })
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** プラン新規モーダルを開く */
    openNewModal: function () {
      this.$refs.propertyPlanModalRef.showNewModal()
    },
    /** プラン編集モーダルを開く */
    openEditModal: function (data) {
      this.$refs.propertyPlanModalRef.showEditModal(data)
    },
    /** プラン複製モーダルを開く */
    openCopyModal: function (data) {
      this.$refs.propertyPlanModalRef.showCopyModal(data)
    },
    /** 絞り込み条件設定モーダルを開く */
    openSearchModal: function () {
      this.$refs.planSearchRef.showModal()
    },
    /** 表示項目切替モーダルを開く */
    openDispModal: function () {
      this.$emit('openDispModal', this.isDetailPage)
    },
    /** 検索ボタン押下 */
    onClickSearch: function (searchForm) {
      this.pageNo = 1
      this.$refs.pagerRef.setCurrentPage(this.pageNo)
      searchForm.pageNo = this.pageNo
      searchForm.dataCount = this.dataCount
      this.onSearch(searchForm)
    },
    /** プランモーダル用の情報を取得 */
    getPropertyPlanData: function (id) {
      axios.get(API_URL.PROPERTY + '/room/list?propertyId=' + id
      ).then(response => {
        this.roomList = response.data.data.roomList
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.roomPlanCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PROPERTY_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.showDetailPage()
    },
    /** CSV出力 */
    downLoadCsv: function () {
      axios.get(API_URL.PROPERTY + '/download/' + this.propertyData.cpropertyId)
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let arrayData = response.data.data
          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'RoomPlanList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clear: function () {
      this.searchForm = {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: '',
        pageNo: '',
        dataCount: ''
      }
    },
    /** マウスアップ */
    mouseup: function (event) {
      if (this.isDetailPage) {
        if (this.isOnListArea && event.button === MOUSE_BUTTON.RIGHT) {
          this.$refs.contextMenuRef.show({ x: event.pageX, y: event.pageY })
        } else {
          this.$refs.contextMenuRef.close()
        }
      }
    },
    /** マウスオーバー */
    mouseover: function (data) {
      this.selectedPlan = data
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD')
      } else {
        return ''
      }
    }
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#property {
  height: 100%;
  min-width:1000px;
  min-height:680px;
}
#property-plan {
  height: 100%;
}
.title_area {
  padding: 10px 0;
  text-align: center;
  width: 260px;
  color: #4472C4;
  background-color: #FEF2CB;
}
.form_area{
  margin: 10px;
  display: flex;
  justify-content: flex-start;
  height: 38px;
  h3 {
    font-size: 1.5em;
    display: inline-block;
  }
  .sub_title_area {
    margin: auto 10px;
  }
  .button_area {
    margin: 5px 0px 10px 0px;
  }
}
.container_main{
  height: calc(100% - 163px);
}
.room_plan_list_area {
  height: 90%;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/PropertyPlanTable.vue